import React, { useState, useEffect } from 'react';
import { Container, Grid, Typography } from '@mui/material';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import CreateRoleForm from '../../../components/roles/CreateRoles';
import EditRoleForm from '../../../components/roles/EditRoles';
import CreateUserForm from '../../../components/CreateUserForm'; // New component
import { useAuth } from '../../../authContext';

const RoleManagement = () => {
  const { currentUser, userPermissions } = useAuth();
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [refreshData, setRefreshData] = useState(false);
  const db = getFirestore();

  useEffect(() => {
    const fetchRolesAndUsers = async () => {
      const rolesSnapshot = await getDocs(collection(db, 'roles'));
      const usersSnapshot = await getDocs(collection(db, 'users'));
      setRoles(rolesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setUsers(usersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchRolesAndUsers();
  }, [refreshData, db]);

  // Check permission
  const hasManageRolesPermission = userPermissions?.includes('manage_roles');

  if (!hasManageRolesPermission) {
    return <Typography>You do not have permission to view this page.</Typography>;
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Role and User Management</Typography>
      
      {/* Create Role Section */}
      <CreateRoleForm onRoleCreated={() => setRefreshData(prev => !prev)} />
      
      {/* New Create User Section */}
      <CreateUserForm onUserCreated={() => setRefreshData(prev => !prev)} />

      {/* Edit User Roles Section */}
      <Typography variant="h5" sx={{ mt: 4 }}>Assign Roles to Users</Typography>
      <Grid container spacing={4}>
        {users.length > 0 ? (
          users.map(user => (
            <Grid item xs={12} sm={6} md={4} key={user.id}>
              <EditRoleForm 
                user={user} 
                roles={roles} 
                onRolesUpdated={() => setRefreshData(prev => !prev)} 
              />
            </Grid>
          ))
        ) : (
          <Typography variant="body2">No users found.</Typography>
        )}
      </Grid>
    </Container>
  );
};

export default RoleManagement;
